
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'
export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    const _advantages = this.info && this.info.advantage && this.info.advantage.advantages ? this.info.advantage.advantages : []
    const _disadvantages = this.info && this.info.advantage && this.info.advantage.disadvantages ? this.info.advantage.disadvantages : []

    return {
      advantages: _advantages && _advantages.length > 3 ? _advantages.slice(0, 3) : _advantages,
      disadvantages: _disadvantages && _disadvantages.length > 3 ? _disadvantages.slice(0, 3) : _disadvantages,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'tedian' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('文字版交易商优缺点', this.info.advantage)
  },
  methods: {
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
